// Tiny utilities for stable serialization and fast string hashing.
// Used by the pipeline to derive cache keys.

export function stableStringify(value: unknown): string {
  if (value === null) return 'null';
  if (typeof value === 'undefined') return 'null';
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : 'null';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'string') return JSON.stringify(value);
  if (Array.isArray(value)) {
    return '[' + value.map(stableStringify).join(',') + ']';
  }
  if (typeof value === 'object') {
    const keys = Object.keys(value as Record<string, unknown>).sort();
    return (
      '{' +
      keys
        .map(
          (k) =>
            JSON.stringify(k) +
            ':' +
            stableStringify((value as Record<string, unknown>)[k]),
        )
        .join(',') +
      '}'
    );
  }
  return 'null';
}

/** FNV-1a 32-bit. Returns a base36 string (~6 chars). Not cryptographic. */
export function fnv1a(str: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(36);
}

export function hashAny(value: unknown): string {
  return fnv1a(stableStringify(value));
}
